module.exports = __webpack_public_path__ + "static/media/ruthless.44f63d01.png";